import { Link } from "react-router-dom";
import { ArrowRight, EnvelopeSimple } from "@phosphor-icons/react";
import { trackEvent } from "@/lib/analytics";

/**
 * "Not ready yet? Stay in the loop." — the second-chance CTA that lives
 * between FAQ and Footer. Catches visitors who scrolled the whole page
 * but bounced before hitting the App Store button.
 *
 * Deliberately linked to /subscribe (not an inline form) so we don't
 * duplicate the footer form. The dedicated page has a cleaner focus
 * plus a source-tag hook for analytics.
 */
export default function StayInLoopCta() {
  return (
    <section
      id="stay-in-the-loop"
      data-testid="stay-in-loop-cta"
      className="relative bg-[#050505] border-t border-white/10 noise"
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-20 md:py-28">
        <div className="relative border border-[#FF2A2A]/30 bg-gradient-to-br from-[#FF2A2A]/[0.08] via-[#050505] to-[#050505] p-8 md:p-14 overflow-hidden">
          {/* Section marker */}
          <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-[#FF2A2A] mb-5 flex items-center gap-2">
            <EnvelopeSimple size={14} weight="bold" />
            § 07 · not ready yet?
          </div>

          <div className="grid lg:grid-cols-12 gap-8 lg:gap-14 items-end">
            <div className="lg:col-span-8">
              <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl xl:text-[72px] font-extrabold tracking-tighter leading-[0.95]">
                Stay in{" "}
                <span className="italic font-light text-white/70">
                  the loop.
                </span>
              </h2>
              <p className="mt-6 text-base md:text-lg text-white/65 max-w-2xl leading-relaxed">
                Not ready to download? Drop an email to be notified about new
                bedside tools, product updates, and the Android launch.
              </p>
            </div>

            <div className="lg:col-span-4 flex lg:justify-end">
              <Link
                to="/subscribe"
                onClick={() =>
                  trackEvent("cta_click", "stay-in-loop-inline", {
                    destination: "/subscribe",
                  })
                }
                data-testid="stay-in-loop-cta-button"
                className="group inline-flex items-center gap-3 bg-[#FF2A2A] hover:bg-[#FF4D4D] text-white font-display font-bold text-lg md:text-xl tracking-tight px-8 py-5 transition-colors w-full lg:w-auto justify-center"
              >
                <span>Get email updates</span>
                <ArrowRight
                  size={20}
                  weight="bold"
                  className="transition-transform group-hover:translate-x-1"
                />
              </Link>
            </div>
          </div>

          {/* Trust row */}
          <div className="mt-10 pt-6 border-t border-white/10 grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-white/40">
              // no spam
            </div>
            <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-white/40">
              // unsubscribe anytime
            </div>
            <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-white/40">
              // data never sold or shared
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
